import VehicleQuoteCreationData from './VehicleQuoteCreationData'

export default VehicleQuoteCreationData
